import { Component, Input } from '@angular/core';

@Component({
    selector: 'bw-bui-tile-legacy',
    templateUrl: './bui-tile.component.html',
    styleUrls: ['./bui-tile.component.scss'],
    standalone: false
})
export class BuiTileComponentLegacy {
  @Input() tileWidth: string;
  @Input() tileHeight: string;
  @Input() tileMargin: string;
  @Input() tilePadding: string;
  @Input() tileBorder: string;
}

@Component({
    selector: 'bui-tile-card-legacy',
    template: `
    <div class="tile-card-wrapper">
      <div class="tile-card"
           [ngStyle]="{'backgroundColor': cardBackground, 'padding': tilePadding, 'border': cardBorder}"
           [ngClass]="{'has-border': cardBorder}"
      >
        <ng-content></ng-content>
      </div>
    </div>
   `,
    styleUrls: ['bui-tile.component.scss'],
    standalone: false
})
export class TileCardComponentLegacy {
  @Input() cardBackground: string;
  @Input() tilePadding: string;
  @Input() cardBorder: string;
}

@Component({
    selector: 'bui-tile-list-item-legacy',
    template: `
    <div class="tile-list-item-wrapper">
      <div class="tile-list-item">
        <ng-content></ng-content>
      </div>
    </div>
   `,
    styleUrls: ['bui-tile.component.scss'],
    standalone: false
})
export class TileListItemComponentLegacy {}
